import { Link } from "react-router-dom";
import { EMAIL, PHONE, PHONE_DISPLAY } from "@/lib/clinic";

export const Footer = () => (
  <footer className="bg-teal-dark text-white/80" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row gap-6 justify-between text-sm">
      <div>
        <p className="font-display text-xl text-white flex items-center gap-2"><img src="/images/logo.png" alt="" className="h-9 w-9 rounded-full" />Smileton Dental</p>
        <p className="mt-1">Dr. Vilayath Mahamadi · BDS, Cosmetic Dental Surgeon</p>
      </div>
      <div className="flex flex-col gap-1">
        <a href={`tel:${PHONE}`} className="hover:text-white" data-testid="footer-phone">{PHONE_DISPLAY}</a>
        <a href={`mailto:${EMAIL}`} className="hover:text-white" data-testid="footer-email">{EMAIL}</a>
        <Link to="/manage" className="hover:text-white font-medium text-white mt-2" data-testid="footer-manage-booking">Manage my booking</Link>
        <Link to="/admin" className="text-white/50 hover:text-white text-xs mt-2" data-testid="footer-staff-login">Staff login</Link>
      </div>
    </div>
    <p className="text-center text-xs text-white/40 pb-6">© {new Date().getFullYear()} Smileton Dental, Sainikpuri</p>
  </footer>
);
